import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getCustomers } from '../../apis/user';
import { Button } from '../../components/Button';
import { DirectoryBar } from '../../components/DirectoryBar';
import { FrontPagination } from '../../components/FrontPagination';
import { H3 } from '../../components/H3';
import { Section } from '../../components/Section';
import { Table } from '../../components/Table';
import { CustomerBoardList } from '../../types/types';
import { FAQPage } from '../CustomerCare/FAQPage';

export const MyPageInquire = () => {
  const history = useHistory();
  const [customerBoards, setCustomerBoards] = useState<CustomerBoardList[]>([]);
  const [page, setPage] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    getCustomers(page, 10).then(r => {
      setCustomerBoards(r?.data.payload.content || []);
      setTotal(r?.data.payload.totalPages || 0);
    }).catch(e => console.log(e));
  }, [page]);

  return (
    <div className="mb-10">
      {/*<DirectoryBar text="1:1 문의하기" backArrow className="md:hidden"/>*/}
      {/*<div>*/}
      {/*    <H3 className="my-4 border-b border-gray-800 py-4">자주 하는 질문</H3>*/}
      {/*    <FAQPage/>*/}
      {/*</div>*/}

      <Section>
        <DirectoryBar text="1:1 문의하기" backArrow className="md:hidden" />
        <div className="flex items-center justify-between border-b border-gray-200 mb-4 pb-2">
          <H3 className="text-14">1:1 문의하기</H3>
          <Button
            text="작성하기"
            to="/mypage/inquire/add"
            className="text-12 font-light rounded-none filled-black w-25 h-8"
          />
        </div>

        {customerBoards.length === 0 ? (
          <div className={'py-20 center text-center'}>
            <p>작성한 1:1문의가 없습니다.</p>
          </div>
        ) : (
          <>
            {/* Mobile */}
            <Section className="md:hidden space-y-4 pt-4 text-12">
              {customerBoards.map((inquiry, index) => (
                <div
                  key={index}
                  className={'flex justify-between pb-4 border-b leading-7'}
                  onClick={() =>
                    history.push(`/mypage/inquire/${inquiry.customerBoardId}`)
                  }>
                  <div>
                    <span className={'text-15 font-bold'}>{inquiry.title}</span>{' '}
                    <br />
                    {inquiry.isReplied ? (
                      <span style={{ color: '#1957C2' }}>답변 완료</span>
                    ) : (
                      '답변 대기중'
                    )}
                  </div>
                  <div className={'text-right'}>
                    문의일 {moment(inquiry.createdAt).format('YYYY.MM.DD')}{' '}
                    <br />
                    문의답변일{' '}
                    {inquiry.repliedAt
                      ? moment(inquiry.repliedAt).format('YYYY.MM.DD')
                      : '-'}
                  </div>
                </div>
              ))}
            </Section>

            {/*Desktop*/}
            <Table className="hidden md:table mt-5">
              <Table.Head>
                <Table.Row>
                  <Table.Th>No.</Table.Th>
                  <Table.Th>작성자</Table.Th>
                  <Table.Th>제목</Table.Th>
                  <Table.Th>문의일</Table.Th>
                  <Table.Th>문의 답변일</Table.Th>
                  <Table.Th>답변 여부</Table.Th>
                  <Table.Th></Table.Th>
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {customerBoards.map((inquiry, index) => (
                  <Table.Row key={index}>
                    <Table.Td>{inquiry.customerBoardId}</Table.Td>
                    <Table.Td>{inquiry.userName}</Table.Td>
                    <Table.Td>{inquiry.title}</Table.Td>
                    <Table.Td>
                      {moment(inquiry.createdAt).format('YYYY.MM.DD')}
                    </Table.Td>
                    <Table.Td>
                      {inquiry.repliedAt
                        ? moment(inquiry.repliedAt).format('YYYY.MM.DD')
                        : '-'}
                    </Table.Td>
                    <Table.Td
                      className={`${inquiry.isReplied ? 'text-blue-500' : ''}`}>
                      {inquiry.isReplied ? '답변 완료' : '답변 대기'}
                    </Table.Td>
                    <Table.Td
                      className={'text-blue-500 cursor-pointer'}
                      onClick={() =>
                        history.push(
                          `/mypage/inquire/${inquiry.customerBoardId}`,
                        )
                      }>
                      상세보기
                    </Table.Td>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            <FrontPagination
              page={page}
              totalPages={total}
              onPrevious={() => page !== 0 && setPage(page - 1)}
              onNext={() => page !== 10 && setPage(page + 1)}
              onNumClick={num => setPage(num - 1)}
            />
          </>
        )}
      </Section>

      <div className="mt-16">
        <H3 className="mb-8 pb-4 border-b border-gray-200 text-14">자주 하는 질문</H3>
        <div className="mr-8"><FAQPage /></div>
      </div>
    </div>
  );
};
